import React from "react";
import { withTranslation } from "react-i18next";

import { getInterventionTotals, round2 } from "../../../../../../util/common";

import "./index.scss";

const InterventionsPriceTotals = ({ interventions, settings, t }) => {
  if (!settings.dms_price_enabled) return null;

  const getTotalAmounts = () => {
    const interventionTotals = getInterventionTotals(
      interventions.filter(i => i.price > 0.01),
      settings
    );

    return interventionTotals;
  };

  const { totalAmount = 0, approvedTotal = 0 } = getTotalAmounts();

  return (
    <div className="interventions-price-totals interventions-price-totals-price-block pdf-block--avoid-break">
      <div className="interventions-price-totals-inner">
        <span className="interventions-price-totals-item">
          <span className="interventions-price-totals-label">
            {t("cc_total_amount").message || "Total amount"}
            {`, ${settings.include_vat ? t("cc_including_VAT").message || "including VAT" : t("cc_excluding_vat").message || "excluding VAT"}`}:
          </span>
          <span className="interventions-price-totals-value">€ {round2(totalAmount).toFixed(2)}</span>
        </span>
        <span className="interventions-price-totals-item">
          <span className="interventions-price-totals-label">
            {t("cc_approved_total").message || "Approved total"}
            {`, ${settings.include_vat ? t("cc_including_VAT").message || "including VAT" : t("cc_excluding_vat").message || "excluding VAT"}`}:
          </span>
          <span className="interventions-price-totals-value">€ {round2(approvedTotal).toFixed(2)}</span>
        </span>
      </div>
    </div>
  );
};

export default withTranslation()(InterventionsPriceTotals);
